import React from 'react'
import PropTypes from 'prop-types'

import { Card, Typography, Skeleton } from '@chilecompra/react-kit/components'

import { Grid } from '../DirectDealSummary.styles'

/**
 * The DirectDealSummary's details buyer.
 */
const DirectDealSummaryDetailBuyer = props => {
  const { loading, sheet } = props

  return (
    <Card padding="24px 16px">
      <Grid container>
        <Grid item margin="0 0 4px">
          {loading ? (
            <Skeleton width="70%" />
          ) : (
            <Typography fontWeight="bold" color="black1" variant="body2" tabIndex="0">
              {sheet?.buyerLegalName}
            </Typography>
          )}
        </Grid>
        <Grid item>
          {loading ? (
            <>
              <Skeleton width="70%" />
              <Skeleton width="40%" />
            </>
          ) : (
            <>
              <Typography color="black1" variant="body2" tabIndex="0">
                {sheet?.buyerDni}
              </Typography>
              <Typography variant="body2" color="black3" tabIndex="0">
                {sheet?.buyerName}
              </Typography>
            </>
          )}
        </Grid>
      </Grid>
    </Card>
  )
}

DirectDealSummaryDetailBuyer.propTypes = {
  loading: PropTypes.bool,
  sheet: PropTypes.shape({
    buyerName: PropTypes.string,
    buyerDni: PropTypes.string,
    buyerLegalName: PropTypes.string
  })
}

export default DirectDealSummaryDetailBuyer
